<template>
  <img
    v-if="isImage"
    :src="icon"
    :class="class"
    :style="{ width: `${size}px` }"
  />
  <n-icon
    v-else
    :name="isError ? 'vehicle_contract_configuration_filled' : icon"
    :size="size"
    :color="color"
    :class="class"
  />
</template>
<script setup lang="ts" name="MicroIcon">
import { computed } from 'vue';
import { NIcon } from '@nio-fe/icon';

const props = withDefaults(
  defineProps<{
    icon?: string;
    size?: string;
    color?: string;
    class?: string;
  }>(),
  {
    size: '24',
  }
);
const isImage = computed(() => {
  return (props.icon || '')?.includes('http');
});
const isError = computed(() => {
  return (props.icon || '')?.includes('n-');
});
</script>

<style lang="scss" scoped></style>
